<template>
  <div
    :class="
      'bg-gradient-to-br ' + classColor + ' dark:from-' + colorName + '-900/20 dark:to-' + colorName + '-800/20 border border-' + colorName + '-200 dark:border-' + colorName + '-800 rounded-lg p-4 hover:shadow-md transition-all'
    "
  >
    <div class="flex items-center justify-between">
      <div
        :class="'w-10 h-10 bg-' + colorName + '-500 dark:bg-' + colorName + '-600 rounded-lg flex items-center justify-center shadow-lg'"
      >
        <i :class="iconClass + ' text-white text-lg'"></i>
      </div>
      <div class="w-3"></div>
      <div class="flex-1 text-right ml-3">
        <h3
          :class="'text-sm font-medium text-' + colorName + '-900 dark:text-' + colorName + '-100 mb-2'"
        >
          {{ title }}
        </h3>
        <div class="space-y-1">
          <p
            :class="[
              'text-sm font-bold text-' + colorName + '-900 dark:text-' + colorName + '-100',
              !showNumbers ? 'blur-sm select-none' : ''
            ]"
          >
            {{ showNumbers ? dollarValue : '••••' }} {{ showNumbers ? '$' : '' }}
          </p>
          <p
            :class="[
              'text-sm font-bold text-' + colorName + '-900 dark:text-' + colorName + '-100',
              !showNumbers ? 'blur-sm select-none' : ''
            ]"
          >
            {{ showNumbers ? dinarValue : '••••' }} {{ showNumbers ? $t("dinar") : '' }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

// eslint-disable-next-line no-unused-vars
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  dollarValue: {
    type: [String, Number],
    default: "0",
  },
  dinarValue: {
    type: [String, Number],
    default: "0",
  },
  showNumbers: {
    type: Boolean,
    default: true,
  },
  colorName: {
    type: String,
    default: "blue",
    validator: (value) => ['red', 'blue', 'green', 'yellow', 'purple', 'indigo', 'orange'].includes(value)
  },
  iconClass: {
    type: String,
    required: true,
  },
  classColor: {
    type: String,
    default: "from-blue-50 to-blue-100",
  },
});
</script>
